import { Permission } from '@/lib/permissions/v1'

export enum UnsentInvoicesRouteName {
    Index = 'finance.invoices.unsent',
}

export default {
    path: 'unsent-invoices',
    name: UnsentInvoicesRouteName.Index,
    component: () => import('@/views/finance/unsent-invoices/Index.vue'),
    meta: {
        label: 'Unsent Invoices',
        auth: true,
        permission: Permission.InvoiceViewAny,
    },
}
